function ServicesSection({ services, onServiceSelect }) {
  return (
    <section className="section section-services reveal" id="services">
      <div className="section-head">
        <span className="section-kicker">Услуги</span>
        <h2>Все направления на одной странице</h2>
        <p>
          Визы, туры, логистика и китайские маршруты собраны в одном блоке —
          можно оставить один запрос, а менеджер подберёт подходящий формат сопровождения.
        </p>
      </div>

      <div className="service-grid">
        {services.map((service) => (
          <article
            className={`service-card service-${service.accent}`}
            key={service.id}
            onClick={() => onServiceSelect(service)}
            role="button"
            tabIndex={0}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                onServiceSelect(service);
              }
            }}
          >
            <img src={service.image} alt={service.title} loading="lazy" decoding="async" />
            <div className="service-body">
              <span>{service.label}</span>
              <h3>{service.title}</h3>
              <p>{service.short}</p>
              <button type="button">Подробнее</button>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default ServicesSection;
